import React from "react";
import GuestCallButton from "@/components/calls/GuestCallButton.jsx";
import GuestChatButton from "@/components/chat/GuestChatButton.jsx";

const LiveCallPanel = ({ mode = "guest", guestInfo, authContext }) => {
  if (mode === "reception") {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <GuestChatButton guestInfo={guestInfo} />
      <GuestCallButton guestInfo={guestInfo} />
    </div>
  );
};

export default LiveCallPanel;
